import axiosInstance from './axiosConfig';

export const duplicateApi = {
  summary: () => axiosInstance.get('/api/duplicates/summary').then((r) => r.data),
  list: (params = {}) => axiosInstance.get('/api/duplicates', { params }).then((r) => r.data),
  scan: () => axiosInstance.post('/api/duplicates/scan').then((r) => r.data),
  merge: (payload) => axiosInstance.post('/api/duplicates/merge', payload).then((r) => r.data),
  remove: (payload) => axiosInstance.post('/api/duplicates/remove', payload).then((r) => r.data),
  ignore: (groupId) => axiosInstance.post(`/api/duplicates/ignore/${groupId}`).then((r) => r.data),
  notDuplicate: (groupId) =>
    axiosInstance.post(`/api/duplicates/not-duplicate/${groupId}`).then((r) => r.data),
  getSettings: () => axiosInstance.get('/api/duplicates/settings').then((r) => r.data),
  updateSettings: (payload) =>
    axiosInstance.put('/api/duplicates/settings', payload).then((r) => r.data),
};

export default duplicateApi;
